import { get } from '@/api/gabed/dispositif';

export default async function transformGetAudit(audit) {
  audit.dateSouhaitee = audit.dateSouhaitee ? new Date(audit.dateSouhaitee) : null;
  audit.datePlanification = audit.datePlanification ? new Date(audit.datePlanification) : null;
  audit.dateRealisation = audit.dateRealisation ? new Date(audit.dateRealisation) : null;
  audit.dateFacture = audit.dateFacture ? new Date(audit.dateFacture) : null;
  const promiseDispositif = [];
  const dispositifIds = audit.otPatrimoine.otsAuditEnfants.map(ot => ot.otPatrimoine.dispositifId);
  dispositifIds.forEach((id) => { promiseDispositif.push(get(id)); });
  const dispositifs = (await Promise.all(promiseDispositif)).map(rslt => rslt.data.result);
  audit.otPatrimoine.otsAuditEnfants.forEach((ot) => {
    const dispositif = dispositifs.find((d) => { return d.id === ot.otPatrimoine.dispositifId; });
    if (dispositif) ot.otPatrimoine.dispositif = dispositif;
  });
  return audit;
}
